

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, StoreJson } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreUberConfigPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public storeJson: any = {};
  public uberconfig: any = {};
  public form: any = {};
  public storeUberConfigFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public created(): void {
    this.setUberConfigFields();
  }

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'UberConfig' },
        })
        .catch(() => {
          // catch block
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.uberconfig.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreUberConfig();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setUberConfigFields(): void {
    this.storeUberConfigFields = [
      {
        key: 'clientId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.uberconfig.lblClientId') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Client Id',v)
          ]
        },
      },
      {
        key: 'clientSecretKey',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          required: true,
          disabled: false,
          label: this.$t('stores.uberconfig.lblClientSecretKey') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Secret Key',v)
          ]
        },
      },
      {
        key: 'baseUrl',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.uberconfig.lblBaseUrl') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Base Url',v)
          ]
        },
      },
      {
        key: 'baseLoginUrl',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.uberconfig.lblBaseLoginUrl') as string,
          loading: false,
          required: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Login Url',v)
          ]
        },
      },
      {
        key: 'uberStoreId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.uberconfig.lblUberStoreId') as string,
          required: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Store Id',v)
          ]
        },
      },
      {
        key: 'placeProvider',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.uberconfig.lblPlaceProvider') as string,
          required: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Place Provider',v)
          ]
        },
      },
      {
        key: 'googleApiKey',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.uberconfig.lblGoogleApiKey') as string,
          required: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Place Key',v)
          ]
        },
      },
      {
        key: 'uberInstructions',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.uberconfig.lblUberInstructions') as string,
          required: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Uber Parts Pick Up Instructions',v)
          ]
        },
      },
      {
        key: 'scope',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          loading: false,
          label: this.$t('stores.uberconfig.lblScope') as string,
          required: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Scope',v)
          ]
        },
      },
    ];
  }

  public updateStore(storeid: number): void {
    this.storeId = storeid;
  }

  public validateStoreUberConfig(): Vue & { validate: () => boolean } {
    return this.$refs.uberConfigForm as Vue & { validate: () => boolean };
  }

  public async saveStoreUberConfig(): Promise<void> {
    if(this.validateStoreUberConfig().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        this.storeModel.storeJson.uberConfig = this.uberconfig;
        if (this.storeModel.id !== 0) {
          const response = await storeService.updateStoreInfo(
            this.storeViewModel,
            this.storeId
          );
          this.storeViewModel = response;
          this.showAlert(
            true,
            this.$t('stores.uberconfig.alertStoreConfigUpdated')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeViewModel.id.toString(),
                tab: 'UberConfig'
              },
            })
            .catch(() => {
              // catch
            });
        } else {
          const response = await storeService.saveStoreInfo(
            this.storeViewModel
          );
          this.storeViewModel = response;
          this.showAlert(
            true,
            this.$t('stores.uberconfig.alertStoreConfigSaved')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeViewModel.id.toString(),
                tab: 'UberConfig'
              },
            })
            .catch(() => {
              // catch Block
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeUberConfigFields);
      const response = await storeService.getStore(this.storeId);

      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.uberconfig = this.storeModel.storeJson.uberConfig || {
        clientId: '',
        clientSecretkey: 0,
        ubserStoreId: '',
        placrProvider: '',
        baseUrl: '',
        baseLoginUrl: '',
        scope: '',
        googleApiKey: '',
        uberInstructions: '',
      };
    } finally {
      this.formlyHideSkeleton(this.storeUberConfigFields);
    }
  }
}
